'use strict';

let labels = {
    initialized: false,
    keywords: "Keywords",
    city: "City",
    region: "State/Region",
    country: "Country",
    language: "Language",
    family: "Job Family",
    type: "Job Type",
    search: "Search",
    clear: "Clear",
    clearAll: "Clear all",
    noItems: "No job postings matching your criteria were found",
    locationGlobal: "Global",
    apply: "Apply",
    cancel: "Cancel",
    changeFilters: "Change filters",
    singularJobs: "job",
    pluralJobs: "jobs"
};

function initLabels() {
    let labelEls = document.querySelectorAll(".jobPostingsAppConfig > .labels > input[type='hidden']");
    if (labelEls && labelEls.length > 0) {
        for (let i = 0; i < labelEls.length; i++) {
            const el = labelEls[i];
            labels[el.name] = el.value;
        };
    }
    labels.initialized = true;
}

export function getLabel(name) {
    if (labels.initialized == false) initLabels();
    if (labels.hasOwnProperty(name)) return labels[name];
    return "Undefined";
}